import React from "react";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportOnce } from "../motionVariants";

// MOCK DATA — sample testimonials to be swapped out for real quotes (LinkedIn
// recs, managers, clients). Names/companies are intentionally generic and
// not tied to Shashank's real employers, so nobody mistakes these for real
// endorsements before he replaces them.
const testimonials = [
    {
        quote: "Shashank turned a vague 'reduce manual review time' ask into a working agentic pipeline in weeks — and it just worked in production from day one.",
        name: "James Anderson",
        role: "Engineering Manager, SaaS Company",
    },
    {
        quote: "He owns things end-to-end. Give him a problem and he comes back with the architecture, the code, and a plan for what breaks next.",
        name: "Sophia Bennett",
        role: "Senior Product Manager, Fintech Startup",
    },
    {
        quote: "Mentored our team through a gnarly admin-panel rebuild without ever making anyone feel behind. Patient, sharp, and easy to work with.",
        name: "Michael Carter",
        role: "Developer, mentee",
    },
];

export default function Testimonials() {
    return (
        <section id="testimonialsRoot">
            <div className="sectionHead">
                <span className="eyebrow">What People Say</span>
                <h2 className="sectionTitle">Kind words</h2>
                {/* <span className="mockBadge">Sample content — to be replaced with real testimonials</span> */}
            </div>
            <motion.div
                id="testimonialsGrid"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
            >
                {testimonials.map((t, index) => (
                    <motion.div className="testimonialCard" key={index} variants={fadeInUp}>
                        <p className="testimonialQuote">&ldquo;{t.quote}&rdquo;</p>
                        <p className="testimonialName">{t.name}</p>
                        <p className="testimonialRole">{t.role}</p>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
}
